import React, { useRef, useState, useEffect } from "react";
import store from "@/redux/store";
import { getWorkProcesses, copyWP } from '@/reducers/WorkProcess'

import { PlayIcon, StopIcon, PlusIcon, ChevronDownIcon, CheckCircleIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'

import { useTranslation, withTranslation, Trans } from "react-i18next";

import {FieldHolder} from "@/components/holders/FieldHolder";
import moment from 'moment';
import {startTimer, stopTimer, startTimer2} from '@/reducers/TimerReducer';
import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
import { CheckIcon,ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { open, close, setPos } from '@/reducers/Window'

export function AddButton({...props}) {
    const { t, i18n, ready } = useTranslation();
    const [query, setQuery] = useState('');
    const [selectedPerson, setSelectedPerson] = useState(null)
    const [data, setData] = useState([]);

    
    useEffect(() => {
                setData((props?.data) ? props?.data : []);

                if(props?.selected) {
                    for(let i in data) {
                        if(data[i]["key"] == props?.selected) {
                            setSelectedPerson( data[i] );
                            break;
                        }
                    }
                }

        return () => {
        };
      }, [data, setData, props, props?.selected]);

    const setSelected = (selectedData) => {
        if(props?.changeEvent) {
            props?.changeEvent(selectedData);
        }
        setSelectedPerson(selectedData)
    }
    
    const filteredPeople =
       query === ''
         ? data
         : data.filter((person) => {
             return data['name'].toLowerCase().includes(query.toLowerCase())
           })    
    

           const addButton = (event) => {
            store.dispatch( open({childWindow: 'addWorker', onSaveHandler: onNewWorkTypeEvent }) );
            
            return false;           
           }           
           
           const onNewWorkTypeEvent = (data) => {
            setData(data);
            setSelectedPerson(null);
            
           }
           
    let vis = true;
     return (
      <>
      <div className="inline-flex rounded-md shadow-xs ">


      <Combobox
           as="div"
           value={selectedPerson}
           onChange={(person) => {
                   setQuery('')
                   setSelected(person)
                 }}           
           className={"relative inline-flex items-center px-2 pr-2  bg-white text-sm font-semibold text-gray-900 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-10 "+ ((vis) ? 'rounded-l-md' : 'rounded-md')}
         >
           <div className={"relative "+ ((vis) ? '' : 'px-0 py-2')}>
             <ComboboxInput
               className="block w-full pr-8 pl-2 rounded-md bg-white text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
               onChange={(event) => setQuery(event.target.value)}
               onBlur={() => setQuery('')}
               displayValue={(person) => ((person) ? ((props?.label) ? props.label(person) : person['name']) : '')}
             />
             <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md focus:outline-hidden">
               <ChevronUpDownIcon className="size-5 text-gray-400" aria-hidden="true" />
             </ComboboxButton>

             {filteredPeople.length > 0 && (
               <ComboboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm">
                 {filteredPeople.map((person) => (
                   <ComboboxOption
                     key={person['username']}
                     value={person}
                     className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-indigo-600 data-focus:text-white data-focus:outline-hidden"
                   >
                     <div className="flex">
                       <span className="truncate group-data-selected:font-semibold">{((props?.label) ? props.label(person) : person['name'])}</span>
                       <span className="ml-2 truncate text-gray-500 group-data-focus:text-indigo-200">
                         {person['username']}
                       </span>
                     </div>

                     <span className="absolute inset-y-0 right-0 hidden items-center pr-4 text-indigo-600 group-data-focus:text-white group-data-selected:flex">
                       <CheckIcon className="size-5" aria-hidden="true" />
                     </span>
                   </ComboboxOption>
                 ))}
               </ComboboxOptions>
             )}
           </div>
         </Combobox>      
      
      
      {vis &&
      
              <div className="relative -ml-px block">
        <div 
        onClick={(event) => addButton(event)}
        className="relative inline-flex items-center rounded-r-md bg-white px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-10 cursor-pointer">
                  <span className="sr-only">Open options</span>
                  <PlusIcon aria-hidden="true" className="size-5" />
                </div>
            </div>
            }
    </div>
    
    </>
    )
}